import React, { FC } from 'react'
import lockIcon from '../assets/lock-icon.png'
import { Button, EmptyPage } from '@sistemiv/s-components'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { getSIdentityUrl } from '../services/http-common'

const NotAuthorized: FC = () => {
  const navigate = useNavigate()
  const { t } = useTranslation()
  return (
    <EmptyPage imageUrl={lockIcon} imageAlt={'Not authorized'} message={t('notAuthorized')}>
      <Button className='text-sky-500 text-lg hover:bg-gray-100 transition-all' onClick={() => navigate(-1)}>
        {t('goBack')}
      </Button>
      <Button
        className='text-sky-500 text-lg hover:bg-gray-100 transition-all'
        onClick={() =>
          (window.location.href = `${getSIdentityUrl()}/login?return_to=${encodeURIComponent(
            window.location.href,
          )}&env=${process.env.REACT_APP_STAGE}`)
        }
      >
        {t('logInFromOtherAcc')}
      </Button>
    </EmptyPage>
  )
}

export default NotAuthorized
